(function (angular) {
    'use strict';

    var modules = [
        // third party
        'ngStorage',
        'ngAnimate',
        'ui.bootstrap-slider',
        'ngFileUpload',
        'ngImgCrop',
        'ui.mask',
        'ngCookies',

        // custom
        'app.layout',
        'app.errors'
    ];

    if (environment.offline) {
        modules = modules.concat(['app.offline']);
    } else {
        modules = modules.concat([
            'app.auth',
            'app.landing',
            'app.purchase',
            'app.activation',
            'app.insight',
            'app.support',
            'app.privacy-policy',
            'app.benefit-info',
            'app.tos',
            'app.sitemap',
            'app.grievance',
            'app.sod',
            'app.directory',
            'app.sgdpppurchase',
        ]);
    }

    angular.module('app', modules);
})(angular);
